import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { validateGoogleSlidesUrl } from 'src/app/services/slides-import/slides-url.validator';
import {
  ModalTemplateComponent,
  PencilModalSizeEnum,
} from 'src/app/standalones/components/modals/modal-template/modal-template.component';
import {
  PencilButtonComponent,
  PencilButtonThemeEnum,
} from 'src/app/standalones/components/pencil-button/pencil-button.component';
import { IconTypes } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';

@Component({
  selector: 'app-slides-import-url-dialog',
  templateUrl: './slides-import-url-dialog.component.html',
  styleUrls: ['./slides-import-url-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [FormsModule, ModalTemplateComponent, TranslateModule, PencilButtonComponent],
})
export class SlidesImportUrlDialogComponent {
  url = '';
  isValid = false;
  readonly PencilModalSizeEnum = PencilModalSizeEnum;
  readonly PencilButtonThemeEnum = PencilButtonThemeEnum;
  readonly IconTypes = IconTypes;

  constructor(private readonly dialogRef: MatDialogRef<SlidesImportUrlDialogComponent>) {}

  onUrlChange(): void {
    this.isValid = validateGoogleSlidesUrl(this.url).valid;
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onImport(): void {
    const result = validateGoogleSlidesUrl(this.url);
    if (result.valid && result.normalizedUrl && result.presentationId) {
      this.dialogRef.close({ url: result.normalizedUrl, presentationId: result.presentationId });
    }
  }
}
